const config={
    '--Czsd':'#B79255',//主色调 前台B79255，用户中心0286DF
    '--Cfs1':'#E1251B',//辅助色1
    '--Cfs2':'#0286DF',//辅助色2
    '--Cfs3':'#409EE9',//辅助色3
    '--Cfs4':'#F7AB01',//辅助色5
    '--Cfs5':'#78C06E',//辅助色6
    '--Cdzs':'#FF6600',//点缀色
    '--FC0':'#000000',//标题文字主色
    '--FC3':'#333333',//标题内容主色
    '--FC6':'#666666',//文字辅色
    '--FC9':'#969696',//时间、提示
    '--FCc':'#C0C4CC',//输入框暗提示
    '--FCe':'#E4E7ED',//分隔线、描边
    '--FCeee':'#eeeeee',//功能背景色
    '--FCfff':'#ffffff',//功能背景色
    '--BC':'#53a8eb',//按钮默认主色上透明90%，前台90%=#be9d66,用户中心90%=#53a8eb
    '--FS1':'16px',//主菜单文字,主标题文字
    '--FS2':'14px',//列表第一行文字,内容文字
    '--FS3':'12px',//时间文字,提示文字
}
let style=[]
for(let i in config){
    style.push(`${i}:${config[i]}`)
}
let el=document.createElement('style')
el.innerText=`:root{${style.join(';')}`
document.head.appendChild(el)
